import { OutputMigration } from '@amzn/awscat-portfolio-assessment-types';
import { Box, Table, TableProps } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { formatCurrencyNoDecimals } from '../../common/LocalizationHelper';
import { getCell } from '../common/awsui-table-helper';

interface Props {
    migration: OutputMigration;
}

interface TableItem {
    item: string;
    cost: number;
}

function MigrationSummaryToolsTraining({ migration }: Props) {
    const currency = migration.currency;

    const columnDefinitions: TableProps.ColumnDefinition<TableItem>[] = [{
        id: 'item',
        header: constants.ITEM,
        cell: item => item.item
    },{
        id: 'cost',
        header: (<Box float='right'>{constants.COST}</Box>),
        cell: item => getCell(formatCurrencyNoDecimals(item.cost, currency))
    }];

    const items: TableItem[] = [
        {
            item: constants.MIGRATION_TOOL,
            cost: migration.tools.migrationTool
        },{
            item: constants.DISCOVERY_TOOL,
            cost: migration.tools.discoveryTool
        },{
            item: constants.TRAINING,
            cost: migration.tools.trainingCost
        },{
            item: constants.ADDITIONAL_COSTS,
            cost: migration.tools.otherCosts
        },{
            item: constants.TOTAL,
            cost: migration.additionalCosts
        }
    ];

    return (
        <Table
            items={items}
            columnDefinitions={columnDefinitions}
        />
    );
}

export default MigrationSummaryToolsTraining;
